import {
    DEALER_LICENCE,
    LOCAL_CLIENT_DEALERS,
    DEALERS_CONTACT_PERSON_PARTICULARS,
    DEALERS_LICENCE_MAILING_ADDRESS,
    OTHER_DETAILS,
    EQUIPMENT_DETAILS,
    TECHNICAL_DATA_INFORMATION,
    EQUIPMENT_TECHNICAL_DATA_LINE,
    EQUIPMENT_TECHNICAL_DATA_M2M,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_OTHERS,
    IMDA_TS_SECURITY_REQUIREMENTS_FOR_RESIDENTIAL_GATEWAYS,
    IMDA_TS_RG_SEC_4_1_LOGIN_CREDENTIALS_MANAGEMENT,
    IMDA_TS_RG_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS,
    IMDA_TS_RG_SEC_4_2_DEVICE_SETUP_AND_ADMINISTRATION,
    IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS,
    IMDA_TS_RG_SEC_4_2_2_INITIAL_SETUP_HANDLING,
    IMDA_TS_RG_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE,
    IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES,
    IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION,
    IMDA_TS_RG_SEC_4_6_VALIDATION_OF_DATA_INPUTS,
    IMDA_TS_RG_SEC_4_7_VULNERABILITIES_REPORTING,
    IMDA_TS_PABX_SEC_4_1_LOGIN_CREDENTIALS_MANAGEMENT,
    IMDA_TS_PABX_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS,
    IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH,
    IMDA_TS_PABX_SEC_4_2_DEVICE_SETUP_AND_ADMINISTRATION,
    IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS,
    IMDA_TS_PABX_SEC_4_2_2_INITIAL_SETUP_HANDLING,
    IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING,
    IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING,
    IMDA_TS_PABX_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE,
    IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES,
    IMDA_TS_PABX_SEC_4_4_DATA_PROTECTION,
    IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY,
    IMDA_TS_PABX_SEC_4_4_2_EVENT_NOTIFICATION,
    IMDA_TS_PABX_SEC_4_4_3_DATA_BACKUP,
    IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK,
    IMDA_TS_PABX_SEC_4_6_VALIDATION_OF_DATA_INPUTS,
    IMDA_TS_PABX_SEC_4_7_REPORTING,
    IMDA_TS_PABX_SEC_4_7_1_REPORT_ON_CALLS,
    IMDA_TS_PABX_SEC_4_7_2_VULNERABILITY_REPORTING,
    IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING,
    IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING,
    IMDA_TS_RG_SEC_4_4_DATA_PROTECTION,
    IMDA_TS_RG_SEC_4_5_LEVEL2_REQUIREMENTS,
    IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH
} from 'common/application.const/Licence/MyApplication/GERCBApplication';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

const mapEquipmentTypesThatShallBeRegisteredUnderTheGerScheme = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.equipmentTypesThatShallBeRegisteredUnderTheGerScheme &&
        licenceDetails?.equipmentInfo[0]?.equipmentTypesThatShallBeRegisteredUnderTheGerScheme.length > 0
    ) {
        return licenceDetails?.equipmentInfo[0]?.equipmentTypesThatShallBeRegisteredUnderTheGerScheme?.map((i: any) => i.mixedValue);
    }
};

const mapEquipmentTypeSubjIMDAGERScheme = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.equipmentTypeSubjIMDAGERScheme &&
        licenceDetails?.equipmentInfo[0]?.equipmentTypeSubjIMDAGERScheme.length > 0
    ) {
        return licenceDetails?.equipmentInfo[0]?.equipmentTypeSubjIMDAGERScheme?.map((i: any) => i.mixedValue);
    }
};

const mapEquipmentTypeForConfirmationOfConformityCofcEquipmentType = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.equipmentTypeForConfirmationOfConformityCofcEquipmentType &&
        licenceDetails?.equipmentInfo[0]?.equipmentTypeForConfirmationOfConformityCofcEquipmentType.length > 0
    ) {
        return licenceDetails?.equipmentInfo[0]?.equipmentTypeForConfirmationOfConformityCofcEquipmentType?.map((i: any) => i.mixedValue);
    }
};

const mapMandatoryImdaSpecNoDesc = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.mandatoryImdaSpecNoDesc &&
        licenceDetails?.equipmentInfo[0]?.mandatoryImdaSpecNoDesc.length > 0
    ) {
        return licenceDetails?.equipmentInfo[0]?.mandatoryImdaSpecNoDesc?.map((i: any) => i.mixedValue);
    }
};

const mapOptionalImdaSpecNoDesc = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.optionalImdaSpecNoDesc &&
        licenceDetails?.equipmentInfo[0]?.optionalImdaSpecNoDesc.length > 0
    ) {
        return licenceDetails?.equipmentInfo[0]?.optionalImdaSpecNoDesc?.map((i: any) => i.mixedValue);
    }
};

const mapNetworkConnection = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.networkConnection &&
        licenceDetails?.equipmentInfo[0]?.networkConnection.length > 0
    ) {
        return licenceDetails?.equipmentInfo[0]?.networkConnection?.map((i: any) => i.mixedValue);
    }
};

const mapAppliedFor = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.appliedFor &&
        licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.appliedFor.length > 0
    ) {
        return licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.appliedFor?.map((i: any) => i.mixedValue);
    }
};

const mapTechnology = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom?.pleaseSelectTechnology &&
        licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom?.pleaseSelectTechnology.length > 0
    ) {
        return licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom?.pleaseSelectTechnology?.map((i: any) => i.mixedValue);
    }
};

const mapEquipmentTechnicalDataRadiocomOthers = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomOthers &&
        licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomOthers.length > 0
    ) {
        return licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomOthers?.map((value: any, i: number) => ({
            'row-id': value?.rowId,
            'tx-freq-range': value?.txFreqRange ?? '-',
            'rx-freq-range': value?.rxFreqRange ?? '-',
            'rf-power-output': value?.rfPowerOutput ?? '-'
        }));
    }
};

const mapLocalClientDealers = (licenceDetails: any) => {
    if (licenceDetails && licenceDetails?.localClientDealers && licenceDetails?.localClientDealers.length > 0) {
        return licenceDetails?.localClientDealers?.map((value: any, i: number) => ({
            no: value?.rowId,
            'dealer-licence-no': value?.dealerLicenceNo ?? '-',
            'dealer-licence-company-name': value?.dealerSLicenceCompanyName ?? '-',
            'name-of-person-responsible': value?.nameOfPersonResponsible ?? '-',
            designation: value?.designation ?? '-',
            'tel-no': value?.telNo ?? '-',
            'mobile-no': value?.mobileNo ?? '-',
            email: value?.email ?? '-',
            address: value?.address ?? '-'
        }));
    }
};

const cancelLicence = (licenceDetails: any, application: string) => {
    return {
        id: 'cancel-licence-details',
        formID: 'cancel-licence-details',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
            [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
            [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

            [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
            [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? ''
        }
    };
};

const renewLicence = (licenceDetails: any, application: string) => {
    return {
        id: 'renew-licence-details',
        formID: 'renew-licence-details',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
            [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
            [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

            [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
            [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
            [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
            [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
            [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
            [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
        }
    };
};

const amendLicence = (licenceDetails: any, application: string) => {
    let equipmentTypesThatShallBeRegisteredUnderTheGerScheme = [];
    let equipmentTypeForConfirmationOfConformityCofcEquipmentType = [];
    let equipmentTypeSubjIMDAGERScheme = [];
    let mandatoryImdaSpecNoDesc = [];
    let optionalImdaSpecNoDesc = [];
    let networkConnection = [];
    let appliedFor = [];
    let technology = [];
    let equipmentTechnicalDataRadiocomOthers = [];
    let localClientDealers = [];

    const mapped = (
        licenceDetails?.iwantToAmend ||
        licenceDetails?.licenceDetails?.iwantToAmend ||
        licenceDetails?.iWantToUpdate ||
        licenceDetails?.licenceDetails?.iWantToUpdate
    )?.map((data: { [key: string]: string }) => {
        return {
            type: data.mixedValue
        };
    });

    equipmentTypesThatShallBeRegisteredUnderTheGerScheme = mapEquipmentTypesThatShallBeRegisteredUnderTheGerScheme(licenceDetails);
    equipmentTypeSubjIMDAGERScheme = mapEquipmentTypeSubjIMDAGERScheme(licenceDetails);
    equipmentTypeForConfirmationOfConformityCofcEquipmentType =
        mapEquipmentTypeForConfirmationOfConformityCofcEquipmentType(licenceDetails);
    mandatoryImdaSpecNoDesc = mapMandatoryImdaSpecNoDesc(licenceDetails);
    optionalImdaSpecNoDesc = mapOptionalImdaSpecNoDesc(licenceDetails);
    networkConnection = mapNetworkConnection(licenceDetails);
    appliedFor = mapAppliedFor(licenceDetails);
    technology = mapTechnology(licenceDetails);
    equipmentTechnicalDataRadiocomOthers = mapEquipmentTechnicalDataRadiocomOthers(licenceDetails);
    localClientDealers = mapLocalClientDealers(licenceDetails);

    return {
        id: 'amend-general-equipment-registration-by-certification-bodies',
        formID: 'amend-general-equipment-registration-by-certification-bodies',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${DEALER_LICENCE}-amend-table`]: [...mapped],
            [`${DEALER_LICENCE}-scheme-type`]: licenceDetails?.applicationInformation?.schemeType ?? '-',
            [`${DEALER_LICENCE}-cb-identification-no`]: licenceDetails?.applicationInformation?.cbIdentificationNo ?? '-',
            [`${DEALER_LICENCE}-cb-applicant-id`]: licenceDetails?.applicationInformation?.cbApplicantId ?? '-',
            [`${DEALER_LICENCE}-name-of-certification-body`]: licenceDetails?.applicationInformation?.nameOfCertificationBodyCb ?? '-',

            [`${LOCAL_CLIENT_DEALERS}-list`]: localClientDealers ?? [],

            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonParticulars?.sameAsApplicantParticulars ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-name`]: licenceDetails?.contactPersonParticulars?.name ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-designation`]: licenceDetails?.contactPersonParticulars?.designation ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-email`]: licenceDetails?.contactPersonParticulars?.email ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-office-tel-number`]: licenceDetails?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-mobile-number`]: licenceDetails?.contactPersonParticulars?.mobileNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-fax-number`]: licenceDetails?.contactPersonParticulars?.faxNumber ?? '-',

            [`${DEALERS_LICENCE_MAILING_ADDRESS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonAddress?.sameAsApplicantAddress ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-building-name`]: licenceDetails?.contactPersonAddress?.address?.buildingName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-postal-code`]: licenceDetails?.contactPersonAddress?.address?.postalCode ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-street-name`]: licenceDetails?.contactPersonAddress?.address?.streetName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-block-house-no`]: licenceDetails?.contactPersonAddress?.address?.blockNo ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-floor-level`]: licenceDetails?.contactPersonAddress?.address?.floor ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-unit`]: licenceDetails?.contactPersonAddress?.address?.unit ?? '-',

            [`${OTHER_DETAILS}-other-details`]: licenceDetails?.otherDetails ?? '-',
            [`${OTHER_DETAILS}-public-contact-no`]: licenceDetails?.otherDetails?.publicContactNo ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${EQUIPMENT_DETAILS}-ger-scheme-equipment-type`]: equipmentTypesThatShallBeRegisteredUnderTheGerScheme ?? [],
            [`${EQUIPMENT_DETAILS}-ger-scheme-equipment-type-subject`]: equipmentTypeSubjIMDAGERScheme ?? [],
            [`${EQUIPMENT_DETAILS}-equipment-type-for-cofc`]: equipmentTypeForConfirmationOfConformityCofcEquipmentType ?? [],
            [`${EQUIPMENT_DETAILS}-mandatory-imda-spec-no-desc`]: mandatoryImdaSpecNoDesc ?? [],
            [`${EQUIPMENT_DETAILS}-optional-imda-spec-no-desc`]: optionalImdaSpecNoDesc ?? [],
            [`${EQUIPMENT_DETAILS}-review-and-confirmed-tech-spec`]:
                licenceDetails?.equipmentInfo[0]?.iWeHaveReviewedAndConfirmedThatTheTechnicalSpecification ?? '-',
            [`${EQUIPMENT_DETAILS}-equipment-description`]: licenceDetails?.equipmentInfo[0]?.equipmentDescription ?? '-',
            [`${EQUIPMENT_DETAILS}-brand-trade-name`]: licenceDetails?.equipmentInfo[0]?.brandTradeName ?? '-',
            [`${EQUIPMENT_DETAILS}-model-no`]: licenceDetails?.equipmentInfo[0]?.modelNo ?? '-',
            [`${EQUIPMENT_DETAILS}-marketing-name`]: licenceDetails?.equipmentInfo[0]?.marketingName ?? '-',
            [`${EQUIPMENT_DETAILS}-manufacturer-name`]: licenceDetails?.equipmentInfo[0]?.manufacturerNameCountry ?? '-',
            [`${EQUIPMENT_DETAILS}-country-of-origin`]: licenceDetails?.equipmentInfo[0]?.countryOfOriginImportCountry ?? '-',
            [`${EQUIPMENT_DETAILS}-fee`]: licenceDetails?.equipmentInfo[0]?.fee ?? '-',
            [`${EQUIPMENT_DETAILS}-network-connection`]: networkConnection ?? [],

            [`${TECHNICAL_DATA_INFORMATION}-test-lab-name`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.testLabName ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-test-report-no`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.testReportNo ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-country-of-lab`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.countryOfLab ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-cb-identification-no`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.cbIdentificationNo ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-name-of-certification-body`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.nameOfCertificationBodyCb ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-product-cert-no`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.productCertNo ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-date-of-product-cert-issued-by-cb`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.dateOfProductCertIssuedByCb ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-applied-for`]: appliedFor ?? [],

            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-auto-dial-feature`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.autoDialFeature ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-protocol`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.protocalType ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-type-of-customer-interface`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.typeOfCustomerInterface ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-line-ports`]: licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.linePorts ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-list-of-customised-terminals-used`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.listOfCustomisedTerminalsUsed ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-list-of-network-interface-cards`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.listOfNetworkInterfaceCards ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-sim-card-provider`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.simCardProvider ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-m2m-service-provider`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.m2MServiceProvider ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-projected-use-life-of-equipment`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.projectedUsefulLifeOfEquipment ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-purposes-services-and-type-of-information`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.purposesServicesAndTypeOfInformation ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO}-channel-spacing`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomInfo?.channelSpacing ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO}-sar-value-w-kg`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomInfo?.sarValueWKg10G ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`]: technology ?? [],

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB119201980MHz21102170MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB317101785MHz18051880MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB725002570MHz26202690MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB8880915MHz925960MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB26814849MHz859894MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB28703748MHz758803MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB3825702620MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB4023002400MHzTddFrequencyBand ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN119201980MHz21102170MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN1 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN317101785MHz18051880MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN3 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN725002570MHz26202690MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN7 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN8880915MHz925960MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN8 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN26814849MHz859894MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN26 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN28703748MHz758803MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN28 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN3825702620MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN38 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN4023002400MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN40 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN7733004200MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN77 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN7833003800MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN78 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN2572650029500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN257 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN2582425027500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN258 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN2612750028350MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN261 ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN119201980MHz21102170MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN1 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN317101785MHz18051880MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN3 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN725002570MHz26202690MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN7 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN8880915MHz925960MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN8 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN26814849MHz859894MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN26 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN28703748MHz758803MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN28 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN3825702620MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN38 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN4023002400MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN40 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN7733004200MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN77 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN7833003800MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN78 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN2572650029500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN257 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN2582425027500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN258 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN2612750028350MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN261 ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_OTHERS}-list`]: equipmentTechnicalDataRadiocomOthers ?? [],

            [`${IMDA_TS_RG_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS}-4-1-1`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req411 ?? '-',

            [`${IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH}-4-1-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req41A ?? '-',
            [`${IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH}-4-1-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req41B ?? '-',
            [`${IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH}-4-1-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req41C ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421A ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421B ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421C ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421D ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-e`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421E ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_2_INITIAL_SETUP_HANDLING}-4-2-2`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req422 ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-2-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req422A ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-2-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req422B ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-2-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req422C ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-3-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423D ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-3-e`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423E ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423A ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423B ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423C ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423D ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE}-4-2-5`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req425 ?? '-',

            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43A ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43B ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43C ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43D ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-e`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43E ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-f`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43F ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-g`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43G ?? '-',

            [`${IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION}-4-4-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req44A ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION}-4-4-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req44B ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION}-4-4-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req44C ?? '-',

            [`${IMDA_TS_RG_SEC_4_4_DATA_PROTECTION}-4-4-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req44 ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_DATA_PROTECTION}-4-5-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentsialGateways?.Req45B ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_DATA_PROTECTION}-4-5-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req45C ?? '-',
            [`${IMDA_TS_RG_SEC_4_5_LEVEL2_REQUIREMENTS}-4-5`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req45 ?? '-',

            [`${IMDA_TS_RG_SEC_4_6_VALIDATION_OF_DATA_INPUTS}-4-6`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req46 ?? '-',

            [`${IMDA_TS_RG_SEC_4_7_VULNERABILITIES_REPORTING}-4-7`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req47 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_1_LOGIN_CREDENTIALS_MANAGEMENT}-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection ?? '-',

            [`${IMDA_TS_PABX_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS}-4-1-1-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req411 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH}-4-1-2-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req412A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH}-4-1-2-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req412B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH}-4-1-2-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req412C ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421C ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-d-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421D ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_2_INITIAL_SETUP_HANDLING}-4-2-2-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req422 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423C ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-d-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423D ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING}-4-2-4-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req424A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING}-4-2-4-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req424B ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE}-4-2-5-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req425 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43C ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-d-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43D ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-e-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43E ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-f-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43F ?? '-',

            [`${IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY}-4-4-1-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req441A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY}-4-4-1-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req441B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY}-4-4-1-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req441C ?? '-',

            [`${IMDA_TS_PABX_SEC_4_4_2_EVENT_NOTIFICATION}-4-4-2-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req442 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_4_3_DATA_BACKUP}-4-4-3-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req443 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK}-4-5-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req45A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK}-4-5-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req45B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK}-4-5-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req45C ?? '-',

            [`${IMDA_TS_PABX_SEC_4_6_VALIDATION_OF_DATA_INPUTS}-4-6-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req46 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_7_1_REPORT_ON_CALLS}-4-7-1-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req471 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_7_2_VULNERABILITY_REPORTING}-4-7-2-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req472 ?? '-'
        }
    };
};

export const formatGERCBApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    let equipmentTypesThatShallBeRegisteredUnderTheGerScheme = [];
    let equipmentTypeForConfirmationOfConformityCofcEquipmentType = [];
    let equipmentTypeSubjIMDAGERScheme = [];
    let mandatoryImdaSpecNoDesc = [];
    let optionalImdaSpecNoDesc = [];
    let networkConnection = [];
    let appliedFor = [];
    let technology = [];
    let equipmentTechnicalDataRadiocomOthers = [];
    let localClientDealers = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    equipmentTypesThatShallBeRegisteredUnderTheGerScheme = mapEquipmentTypesThatShallBeRegisteredUnderTheGerScheme(licenceDetails);
    equipmentTypeSubjIMDAGERScheme = mapEquipmentTypeSubjIMDAGERScheme(licenceDetails);
    equipmentTypeForConfirmationOfConformityCofcEquipmentType =
        mapEquipmentTypeForConfirmationOfConformityCofcEquipmentType(licenceDetails);
    mandatoryImdaSpecNoDesc = mapMandatoryImdaSpecNoDesc(licenceDetails);
    optionalImdaSpecNoDesc = mapOptionalImdaSpecNoDesc(licenceDetails);
    networkConnection = mapNetworkConnection(licenceDetails);
    appliedFor = mapAppliedFor(licenceDetails);
    technology = mapTechnology(licenceDetails);
    equipmentTechnicalDataRadiocomOthers = mapEquipmentTechnicalDataRadiocomOthers(licenceDetails);
    localClientDealers = mapLocalClientDealers(licenceDetails);

    licence = {
        id: 'general-equipment-registration-by-certification-bodies',
        formID: 'general-equipment-registration-by-certification-bodies',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${DEALER_LICENCE}-scheme-type`]: licenceDetails?.applicationInformation?.schemeType ?? '-',
            [`${DEALER_LICENCE}-cb-identification-no`]: licenceDetails?.applicationInformation?.cbIdentificationNo ?? '-',
            [`${DEALER_LICENCE}-cb-applicant-id`]: licenceDetails?.applicationInformation?.cbApplicantId ?? '-',
            [`${DEALER_LICENCE}-name-of-certification-body`]: licenceDetails?.applicationInformation?.nameOfCertificationBodyCb ?? '-',

            [`${LOCAL_CLIENT_DEALERS}-list`]: localClientDealers ?? [],

            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonParticulars?.sameAsApplicantParticulars ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-name`]: licenceDetails?.contactPersonParticulars?.name ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-designation`]: licenceDetails?.contactPersonParticulars?.designation ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-email`]: licenceDetails?.contactPersonParticulars?.email ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-office-tel-number`]: licenceDetails?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-mobile-number`]: licenceDetails?.contactPersonParticulars?.mobileNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-fax-number`]: licenceDetails?.contactPersonParticulars?.faxNumber ?? '-',

            [`${DEALERS_LICENCE_MAILING_ADDRESS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonAddress?.sameAsApplicantAddress ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-building-name`]: licenceDetails?.contactPersonAddress?.address?.buildingName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-postal-code`]: licenceDetails?.contactPersonAddress?.address?.postalCode ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-street-name`]: licenceDetails?.contactPersonAddress?.address?.streetName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-block-house-no`]: licenceDetails?.contactPersonAddress?.address?.blockNo ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-floor-level`]: licenceDetails?.contactPersonAddress?.address?.floor ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-unit`]: licenceDetails?.contactPersonAddress?.address?.unit ?? '-',

            [`${OTHER_DETAILS}-other-details`]: licenceDetails?.otherDetails ?? '-',
            [`${OTHER_DETAILS}-public-contact-no`]: licenceDetails?.otherDetails?.publicContactNo ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${EQUIPMENT_DETAILS}-ger-scheme-equipment-type`]: equipmentTypesThatShallBeRegisteredUnderTheGerScheme ?? [],
            [`${EQUIPMENT_DETAILS}-ger-scheme-equipment-type-subject`]: equipmentTypeSubjIMDAGERScheme ?? [],
            [`${EQUIPMENT_DETAILS}-equipment-type-for-cofc`]: equipmentTypeForConfirmationOfConformityCofcEquipmentType ?? [],
            [`${EQUIPMENT_DETAILS}-mandatory-imda-spec-no-desc`]: mandatoryImdaSpecNoDesc ?? [],
            [`${EQUIPMENT_DETAILS}-optional-imda-spec-no-desc`]: optionalImdaSpecNoDesc ?? [],
            [`${EQUIPMENT_DETAILS}-review-and-confirmed-tech-spec`]:
                licenceDetails?.equipmentInfo[0]?.iWeHaveReviewedAndConfirmedThatTheTechnicalSpecification ?? '-',
            [`${EQUIPMENT_DETAILS}-equipment-description`]: licenceDetails?.equipmentInfo[0]?.equipmentDescription ?? '-',
            [`${EQUIPMENT_DETAILS}-brand-trade-name`]: licenceDetails?.equipmentInfo[0]?.brandTradeName ?? '-',
            [`${EQUIPMENT_DETAILS}-model-no`]: licenceDetails?.equipmentInfo[0]?.modelNo ?? '-',
            [`${EQUIPMENT_DETAILS}-marketing-name`]: licenceDetails?.equipmentInfo[0]?.marketingName ?? '-',
            [`${EQUIPMENT_DETAILS}-manufacturer-name`]: licenceDetails?.equipmentInfo[0]?.manufacturerNameCountry ?? '-',
            [`${EQUIPMENT_DETAILS}-country-of-origin`]: licenceDetails?.equipmentInfo[0]?.countryOfOriginImportCountry ?? '-',
            [`${EQUIPMENT_DETAILS}-fee`]: licenceDetails?.equipmentInfo[0]?.fee ?? '-',
            [`${EQUIPMENT_DETAILS}-network-connection`]: networkConnection ?? [],

            [`${TECHNICAL_DATA_INFORMATION}-test-lab-name`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.testLabName ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-test-report-no`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.testReportNo ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-country-of-lab`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.countryOfLab ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-cb-identification-no`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.cbIdentificationNo ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-name-of-certification-body`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.nameOfCertificationBodyCb ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-product-cert-no`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.productCertNo ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-date-of-product-cert-issued-by-cb`]:
                licenceDetails?.equipmentInfo[0]?.technicalInformationSingle?.dateOfProductCertIssuedByCb ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-applied-for`]: appliedFor ?? [],

            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-auto-dial-feature`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.autoDialFeature ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-protocol`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.protocalType ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-type-of-customer-interface`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.typeOfCustomerInterface ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-line-ports`]: licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.linePorts ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-list-of-customised-terminals-used`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.listOfCustomisedTerminalsUsed ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_LINE}-list-of-network-interface-cards`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataLine?.listOfNetworkInterfaceCards ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-sim-card-provider`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.simCardProvider ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-m2m-service-provider`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.m2MServiceProvider ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-projected-use-life-of-equipment`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.projectedUseLifeOfEquipment ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-purposes-services-and-type-of-information`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.purposesServicesAndTypeOfInformation ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO}-channel-spacing`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomInfo?.channelSpacing ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO}-sar-value-w-kg`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomInfo?.sarValueWKg10G ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`]: technology ?? [],

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB119201980MHz21102170MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB317101785MHz18051880MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB725002570MHz26202690MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB8880915MHz925960MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB3825702620MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB4023002400MHzTddFrequencyBand ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN119201980MHz21102170MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN1 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN317101785MHz18051880MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN3 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN725002570MHz26202690MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN7 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN8880915MHz925960MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN8 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN26814849MHz859894MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN26 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN28703748MHz758803MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN28 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN3825702620MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN38 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN4023002400MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN40 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN7733004200MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN77 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN7833003800MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN78 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN2572650029500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN257 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN2582425027500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN258 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN2612750028350MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN261 ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN119201980MHz21102170MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN1 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN317101785MHz18051880MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN3 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN725002570MHz26202690MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN7 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN8880915MHz925960MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN8 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN26814849MHz859894MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN26 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN28703748MHz758803MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN28 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN3825702620MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN38 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN4023002400MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN40 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN7733004200MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN77 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN7833003800MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN78 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN2572650029500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN257 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN2582425027500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN258 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN2612750028350MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN261 ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_OTHERS}-list`]: equipmentTechnicalDataRadiocomOthers ?? [],

            [`${IMDA_TS_RG_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS}-4-1-1`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req411 ?? '-',

            [`${IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH}-4-1-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req41A ?? '-',
            [`${IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH}-4-1-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req41B ?? '-',
            [`${IMDA_TS_RG_SEC_4_1_MINIMUM_PASSWORD_STRENGTH}-4-1-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req41C ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421A ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421B ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421C ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421D ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-e`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req421E ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_2_INITIAL_SETUP_HANDLING}-4-2-2`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req422 ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-2-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req422A ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-2-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req422B ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-2-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req422C ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-3-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423D ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_2_AUTHENTICATION_HANDLING}-4-2-3-e`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423E ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423A ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423B ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423C ?? '-',
            [`${IMDA_TS_RG_SEC_4_2_3_CREDENTIALS_HANDLING}-4-2-3-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req423D ?? '-',

            [`${IMDA_TS_RG_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE}-4-2-5`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req425 ?? '-',

            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43A ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43B ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43C ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-d`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43D ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-e`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43E ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-f`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43F ?? '-',
            [`${IMDA_TS_RG_SEC_4_3_FIRMWARE_UPDATES}-4-3-g`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req43G ?? '-',

            [`${IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION}-4-4-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req44A ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION}-4-4-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req44B ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_WIRELESS_ACCESS_PROTECTION}-4-4-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req44C ?? '-',

            [`${IMDA_TS_RG_SEC_4_4_DATA_PROTECTION}-4-4-a`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req44 ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_DATA_PROTECTION}-4-5-b`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentsialGateways?.Req45B ?? '-',
            [`${IMDA_TS_RG_SEC_4_4_DATA_PROTECTION}-4-5-c`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req45C ?? '-',
            [`${IMDA_TS_RG_SEC_4_5_LEVEL2_REQUIREMENTS}-4-5`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req45 ?? '-',

            [`${IMDA_TS_RG_SEC_4_6_VALIDATION_OF_DATA_INPUTS}-4-6`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req46 ?? '-',

            [`${IMDA_TS_RG_SEC_4_7_VULNERABILITIES_REPORTING}-4-7`]:
                licenceDetails?.imdaTsSecurityRequirementsForResidentialGateways?.Req47 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_1_LOGIN_CREDENTIALS_MANAGEMENT}-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection ?? '-',

            [`${IMDA_TS_PABX_SEC_4_1_1_FACTORY_PRE_LOADED_LOGIN_CREDENTIALS}-4-1-1-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req411 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH}-4-1-2-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req412A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH}-4-1-2-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req412B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_1_2_MINIMUM_PASSWORD_LENGTH}-4-1-2-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req412C ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421C ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_1_DEVICE_PRE_LOADED_SETTINGS}-4-2-1-d-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req421D ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_2_INITIAL_SETUP_HANDLING}-4-2-2-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req422 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423C ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_3_AUTHENTICATION_HANDLING}-4-2-3-d-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req423D ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING}-4-2-4-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req424A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_2_4_PASSWORD_HANDLING}-4-2-4-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req424B ?? '-',

            [`${IMDA_TS_PABX_SEC_4_2_5_DEVICE_MANAGEMENT_INTERFACE}-4-2-5-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req425 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43C ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-d-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43D ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-e-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43E ?? '-',
            [`${IMDA_TS_PABX_SEC_4_3_FIRMWARE_UPDATES}-4-3-f-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req43F ?? '-',

            [`${IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY}-4-4-1-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req441A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY}-4-4-1-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req441B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_4_1_DATA_CONFIDENTIALITY}-4-4-1-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req441C ?? '-',

            [`${IMDA_TS_PABX_SEC_4_4_2_EVENT_NOTIFICATION}-4-4-2-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req442 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_4_3_DATA_BACKUP}-4-4-3-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req443 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK}-4-5-a-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req45A ?? '-',
            [`${IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK}-4-5-b-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req45B ?? '-',
            [`${IMDA_TS_PABX_SEC_4_5_SECURING_THE_TRUNK}-4-5-c-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req45C ?? '-',

            [`${IMDA_TS_PABX_SEC_4_6_VALIDATION_OF_DATA_INPUTS}-4-6-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req46 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_7_1_REPORT_ON_CALLS}-4-7-1-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req471 ?? '-',

            [`${IMDA_TS_PABX_SEC_4_7_2_VULNERABILITY_REPORTING}-4-7-2-pabx`]:
                licenceDetails?.imdaTsSecurityRequirementsForPabxDeclarationSection?.Req472 ?? '-'
        }
    };

    if (transactionType === 'Cancel') {
        licence = cancelLicence(licenceDetails, 'IMDA-IRIS-Work-LICApplication');
    }

    if (transactionType === 'Renew') {
        licence = renewLicence(licenceDetails, 'IMDA-IRIS-Work-LICApplication');
    }

    if (transactionType === 'Amend') {
        licence = amendLicence(licenceDetails, 'IMDA-IRIS-Work-LICApplication');
    }

    return licence;
};

const gercbPayloadApplication = {
    formatGERCBApplication
};

export default gercbPayloadApplication;
